export default "https://assets.pclncdn.com/web/next-landing/01bc7bc/_next/static/images/road-trip-mobile-1c5af87173c97eac2a3f97f03f776734.webp";